import React from "react";
import style from "./style.module.scss";
import moment from "moment/moment";

function ChildTableRow({ data, lastRow }) {
  return (
    <tr className={`${style.line} ${!lastRow ? style.line_after : ""}`}>
      <td className={style.child_table_cell}>
        <div className={style.align_center}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.75024 15.3888H3.75974L2.2671 9.61176C2.19625 9.34602 2.04583 9.11109 1.82455 9.00036C1.27233 8.7221 0.663826 8.50065 0 8.38896V8.16654H3.20655C3.6491 8.16654 3.98101 8.50065 4.03633 8.88867L4.81079 13.0558L6.80033 8.16654H8.73552L5.75024 15.3888ZM9.84189 15.3888H7.96202L9.50998 8.16654H11.3898L9.84189 15.3888ZM13.8219 10.1673C13.8772 9.77836 14.2092 9.55595 14.5964 9.55595C15.2049 9.5001 15.8678 9.61179 16.4209 9.88909L16.7529 8.3341C16.1997 8.11169 15.5912 8 15.0389 8C13.2144 8 11.8867 9.00039 11.8867 10.3888C11.8867 11.445 12.8272 11.9996 13.491 12.3337C14.2092 12.6669 14.4858 12.8893 14.4304 13.2224C14.4304 13.7221 13.8772 13.9446 13.325 13.9446C12.6612 13.9446 11.9974 13.778 11.3898 13.4997L11.0579 15.0557C11.7218 15.333 12.4399 15.4447 13.1038 15.4447C15.1496 15.4995 16.4209 14.5001 16.4209 13C16.4209 11.1109 13.8219 11.0002 13.8219 10.1673ZM23 15.3888L21.5074 8.16654H19.9041C19.5722 8.16654 19.2403 8.38896 19.1297 8.7221L16.3657 15.3888H18.3009L18.6871 14.3335H21.0649L21.2861 15.3888H23ZM20.1806 10.1115L20.7329 12.8334H19.1849L20.1806 10.1115Z"
              fill="#172B85"
            />
          </svg>
          {data?.card_type}
        </div>
      </td>
      <td className={style.child_table_cell}>
        <div className={style.align_center}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="12"
            viewBox="0 0 13 12"
            fill="none"
          >
            <path
              d="M6.5 1.125C5.53582 1.125 4.59329 1.41091 3.7916 1.94659C2.98991 2.48226 2.36507 3.24363 1.99609 4.13442C1.62711 5.02521 1.53057 6.00541 1.71867 6.95107C1.90678 7.89672 2.37108 8.76536 3.05286 9.44715C3.73464 10.1289 4.60328 10.5932 5.54894 10.7813C6.49459 10.9694 7.47479 10.8729 8.36558 10.5039C9.25637 10.1349 10.0177 9.51009 10.5534 8.7084C11.0891 7.90671 11.375 6.96418 11.375 6C11.3736 4.70749 10.8596 3.46831 9.94564 2.55436C9.0317 1.64042 7.79251 1.12636 6.5 1.125ZM8.64031 5.14031L6.01531 7.76531C5.98049 7.80018 5.93913 7.82784 5.8936 7.84671C5.84808 7.86558 5.79928 7.87529 5.75 7.87529C5.70072 7.87529 5.65192 7.86558 5.6064 7.84671C5.56088 7.82784 5.51952 7.80018 5.48469 7.76531L4.35969 6.64031C4.28932 6.56995 4.24979 6.47451 4.24979 6.375C4.24979 6.27549 4.28932 6.18005 4.35969 6.10969C4.43005 6.03932 4.52549 5.99979 4.625 5.99979C4.72451 5.99979 4.81995 6.03932 4.89031 6.10969L5.75 6.96984L8.10969 4.60969C8.14453 4.57485 8.18589 4.54721 8.23142 4.52835C8.27694 4.5095 8.32573 4.49979 8.375 4.49979C8.42428 4.49979 8.47307 4.5095 8.51859 4.52835C8.56411 4.54721 8.60547 4.57485 8.64031 4.60969C8.67516 4.64453 8.70279 4.68589 8.72165 4.73141C8.74051 4.77694 8.75021 4.82573 8.75021 4.875C8.75021 4.92427 8.74051 4.97306 8.72165 5.01859C8.70279 5.06411 8.67516 5.10547 8.64031 5.14031Z"
              fill="#37B450"
            />
          </svg>
          {data?.code}
        </div>
      </td>
      <td className={style.child_table_cell}>
        {moment(data?.transaction_date).format("MM/D/YYYY")}
      </td>
      <td className={style.child_table_cell}>{data?.key_entry}</td>
      <td className={style.child_table_cell}>{data.cardholder_acct_number}</td>
      <td className={style.child_table_cell}>{data?.authorization_number}</td>
      <td className={style.child_table_cell}>{data?.reference_number}</td>
      <td className={style.child_table_cell}>{data?.voucher}</td>
      <td className={style.child_table_cell}>$ {data?.trans_amt}.00</td>
      <td className={style.child_table_cell}>$ {data?.net_amt}.00</td>
      <td className={style.child_table_cell}>$ {data?.adj_amt}.00</td>
    </tr>
  );
}

export default ChildTableRow;
